import Equipment from 'classes/Equipment';
import buildQuery from 'odata-query';
import ODataUtil from 'utils/ODataUtil';
import { ApiRequest } from './ApiUtils';

const apiEndpoint = "/Equipment";


const getEquipment = async function getEquipment(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, Equipment.expand, orderByInfo, orderByDirection, filters
  );
  const filter = {};
  const isDefaults = filters.find(r => r.defaults);
  
  if (isDefaults) {
    const defaults = isDefaults.defaults;
    if(defaults.projectId) filter["ihwi/workitem/project/projectId"] = { eq: { type: 'guid', value: defaults.projectId }};
    if(defaults.inspectionNumber) filter["ihwi/inspection/inspectionNumber"] = defaults.inspectionNumber;
  };

  const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data = await ApiRequest(apiEndpoint, params);
  return Equipment.convertToTableRows(data);
}

export { getEquipment };